// secureSDK.js
// 🎯 개선된 SDK 관리 시스템
let defaultSDK = null;            // 기본 SDK (로그인 시 1회 생성)
const roleSDKCache = {};          // Role Playground 전용 SDK 캐시
let currentSDK = null;            // 현재 사용 중인 SDK

const waitForSDK = () => {
  return new Promise((resolve, reject) => {
    if (window.SecureSDK) {
      resolve();
    } else {
      const checkInterval = setInterval(() => {
        if (window.SecureSDK) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);

      // 10초 후에도 SDK가 로드되지 않으면 에러
      setTimeout(() => {
        clearInterval(checkInterval);
        reject(new Error('SDK 로드 시간 초과'));
      }, 10000);
    }
  });
};

// SDK 인스턴스 생성 (내부 함수)
const createNewSDK = async (jwtToken, sessionId = null) => {
  try {
    if (!jwtToken) throw new Error('JWT 토큰이 필요합니다.');
    await waitForSDK();

    const startTime = performance.now();

    const SDK_URL = process.env.VUE_APP_SECURE_AI_CLIENT_SDK_URL;
    const LLM_URL = process.env.VUE_APP_LLM_URL;
    const instance = new window.SecureSDK();
    await instance.initialize({
      serverUrl: SDK_URL,
      jwt: jwtToken,
      cryptoType: process.env.VUE_APP_CRYPTO_TYPE || 'bouncycastle',
      timeoutTotal: 360000,
      secureMode: {
        ...(sessionId && { sessionId }),
        policies: [{
          name: 'sgt-chat',
          domain: new URL(LLM_URL).host,
          include: ['/api/chat'],
          mode: 'chat'
        }]
      }
    });
    
    // JWT 추적을 위해 현재 JWT 저장
    instance.currentJWT = jwtToken;
    
    const endTime = performance.now();
    console.log(`[SDK] 새 SDK 인스턴스 생성 완료 (${Math.round(endTime - startTime)}ms)`);
    
    return instance;
  } catch (error) {
    console.error('SDK 인스턴스 생성 실패:', error);
    throw error;
  }
};

// 🔄 기본 SDK 초기화 (로그인 시 1회만)
export const initializeDefaultSDK = async (jwtToken) => {
  if (!defaultSDK) {
    console.log('[SDK] 🚀 기본 SDK 최초 초기화...');
    defaultSDK = await createNewSDK(jwtToken);
    console.log('[SDK] 기본 SDK 생성 완료');
  }
  currentSDK = defaultSDK;
  return defaultSDK;
};


// 🔄 Role SDK 가져오기 (캐시 활용)
export const getRoleSDK = async (roleJWT, roleKey) => {
  if (!roleSDKCache[roleKey]) {
    console.log(`[SDK] 🔄 Role SDK 생성: ${roleKey}`);
    roleSDKCache[roleKey] = await createNewSDK(roleJWT);
  }
  currentSDK = roleSDKCache[roleKey];
  return roleSDKCache[roleKey];
};

// 🔄 기본 SDK로 복구
export const restoreDefaultSDK = () => {
  if (!defaultSDK) {
    console.warn('[SDK] 기본 SDK 복구 실패: defaultSDK가 null입니다.');
  }
  currentSDK = defaultSDK;
  return defaultSDK;
};

// 현재 SDK 가져오기
export const getSecureSDK = () => {
  const sdk = currentSDK || defaultSDK;
  if (!sdk) {
    console.warn('[SDK] getSecureSDK: SDK가 null입니다. currentSDK:', !!currentSDK, 'defaultSDK:', !!defaultSDK);
  }
  return sdk;
};

// 🔄 레거시 호환성을 위한 함수 (기존 코드와의 호환성 유지)
export const updateSDKToken = async (jwtToken) => {
  try {
    if (!jwtToken) throw new Error('JWT 토큰이 필요합니다.');
    
    // 기본 SDK가 있고 JWT가 같으면 기존 SDK 재사용
    if (defaultSDK && defaultSDK.currentJWT === jwtToken) {
      console.log('[SDK] JWT 동일, 기본 SDK 재사용');
      currentSDK = defaultSDK;
      return defaultSDK;
    }
    
    // JWT가 다르면 기본 SDK 업데이트
    console.log('[SDK] JWT 변경됨, 기본 SDK 업데이트');
    defaultSDK = await createNewSDK(jwtToken);
    currentSDK = defaultSDK;
    return defaultSDK;
  } catch (error) {
    console.error('[SDK] JWT 토큰 업데이트 실패:', error);
    throw error;
  }
};

// 🔄 전체 SDK 초기화: 새로운 인스턴스 생성 (레거시 호환성)
export const initializeSecureSDK = async (jwtToken) => {
  return await updateSDKToken(jwtToken);
};


